import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=048f549b&scoped=true&"
import script from "./discount.vue?vue&type=script&lang=js&"
export * from "./discount.vue?vue&type=script&lang=js&"
import style0 from "./discount.vue?vue&type=style&index=0&id=048f549b&scoped=true&lang=css&"
import style1 from "./discount.vue?vue&type=style&index=1&id=048f549b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048f549b",
  null
  
)

export default component.exports